import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import DateRangePickerML from '@/components/DateRangePickerML';

import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import webStorage from '@/utils/storageManager';

import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = React.forwardRef((props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const {
    orderNo,
    status,
    giftReceiveMethod,
    exchangeBeginDateTime,
    exchangeEndDateTime,
    giftType,
    shelfId,
    mobile,
    giftTitle,
    memberCode,
    masterOrderNo,
  } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      orderNo,
      status,
      giftReceiveMethod,
      giftType,
      shelfId,
      mobile,
      giftTitle,
      memberCode,
      masterOrderNo,
    },
  });
  //活动时间的重置
  const [isReset, setIsReset] = useState();
  //礼品类别
  const ACTIVITY_POINTS_GIFT_TYPE = webStorage
    .get('DICTOBJ')
    ?.ACTIVITY_POINTS_GIFT_TYPE?.map((item) => ({
      label: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
      value: item.dictCode,
    }));
  //兑换方式
  // const GET_TYPE = webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_RECEIVE_METHOD;
  //兑换状态
  const ACTIVITY_POINTS_ORDER_STATUS =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_ORDER_STATUS;
  // 每个输入框清除数据
  //置空输入框
  //礼品状态
  const handleClearStatus = () => {
    setValue('status', '');
  };

  //礼品类别
  // const handleClearType = () => {
  //   setValue('giftReceiveMethod', '');
  // };
  //礼品类别
  const handleClearGiftType = () => {
    setValue('giftType', '');
  };
  const watchStatus = watch('status');
  const watchGiftType = watch('giftType');
  // const watchType = watch('giftReceiveMethod');

  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
      exchangeBeginDateTime: submitData.date?.startDate,
      exchangeEndDateTime: submitData.date?.endDate,
    };

    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      orderNo: '',
      status: '',
      giftReceiveMethod: '',
      giftType: '',
      shelfId: '',
      mobile: '',
      giftTitle: '',
      memberCode: '',
      masterOrderNo: '',
      date: { startDate: null, endDate: null },
    };
    reset(resetSearch);
    setIsReset(true);
    restClick && restClick(resetSearch);
  };

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line">
              <Controller
                render={(rp) => (
                  <TextField
                    name="orderNo"
                    variant="standard"
                    label="订单编号"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('orderNo', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('orderNo', '');
                            }}
                            edge="end"
                          >
                            {orderNo ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="orderNo"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <FormControl variant="standard" className="date">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="兑换时间"
                      startText="开始日期"
                      endText="结束日期"
                      defaultStartDate={exchangeBeginDateTime}
                      defaultEndDate={exchangeEndDateTime}
                      rp={rp}
                      setValue={setValue}
                      onChange={() => setIsReset(false)}
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>

              <Controller
                render={(rp) => (
                  <TextField
                    name="shelfId"
                    variant="standard"
                    label="货架ID"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('shelfId', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('shelfId', '');
                            }}
                            edge="end"
                          >
                            {shelfId ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="shelfId"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>礼品类型</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('status', '')}
                              edge="end"
                            >
                              {/* {getValues().memberCode ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )} */}
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {ACTIVITY_POINTS_GIFT_TYPE &&
                        ACTIVITY_POINTS_GIFT_TYPE.map((item) => (
                          <MenuItem
                            key={item.value}
                            value={item.value}
                            name={item.label}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label="礼品类型"
                  name="giftType"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearGiftType}
                  clearValue={watchGiftType}
                ></ClearIconML>
              </FormControl>
            </Box>
            <Box className="line" mt={3}>
              <FormControl variant="standard" className="channel">
                <InputLabel>兑换状态</InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {ACTIVITY_POINTS_ORDER_STATUS.map((item) => (
                        <MenuItem
                          key={item.dictCode}
                          value={item.dictCode}
                          name={item.dictCode}
                        >
                          {item.nameZh}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label="兑换状态"
                  variant="standard"
                  name="status"
                  defaultValue=""
                  control={control}
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
              <Controller
                render={(rp) => (
                  <TextField
                    name="mobile"
                    variant="standard"
                    label="收件人手机号"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                            }}
                            edge="end"
                          >
                            {mobile ? <ClearIcon className="clear-icon" /> : ''}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <Controller
                render={(rp) => (
                  <TextField
                    name="memberCode"
                    variant="standard"
                    label="会员号"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('memberCode', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('memberCode', '');
                            }}
                            edge="end"
                          >
                            {memberCode ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="memberCode"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <Controller
                render={(rp) => (
                  <TextField
                    name="giftTitle"
                    variant="standard"
                    label="礼品标题"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('giftTitle', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('giftTitle', '');
                            }}
                            edge="end"
                          >
                            {giftTitle ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="giftTitle"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
            </Box>
            <Box className="line" mt={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="masterOrderNo"
                    variant="standard"
                    label="总单号"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('masterOrderNo', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('masterOrderNo', '');
                            }}
                            edge="end"
                          >
                            {masterOrderNo ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="masterOrderNo"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <div></div>
              <div></div>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_point_mall_exchange_record_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});

export default SearchGroup;
